import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "flex-fill" }
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "container-fluid no-padding-style" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, null, -1)
const _hoisted_9 = { class: "col-md-10" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "menu-box" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-lines-fill" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-lines-fill" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_printer_dialog = _resolveComponent("printer-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.language.analyticals), 1)
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control-sel outline-transp",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentMonth) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getListMonths, (oMonth) => {
              return (_openBlock(), _createElementBlock("option", {
                key: oMonth.id,
                value: oMonth.id
              }, _toDisplayString(oMonth.label), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.currentMonth]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.language.lists), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.printCusomrsList && _ctx.printCusomrsList(...args)))
                    }, [
                      _hoisted_12,
                      _createTextVNode("  " + _toDisplayString(_ctx.language.customers) + " - " + _toDisplayString(_ctx.language.print_list), 1)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.printCusomrsSitList && _ctx.printCusomrsSitList(...args)))
                    }, [
                      _hoisted_13,
                      _createTextVNode("  " + _toDisplayString(_ctx.language.customers) + " - " + _toDisplayString(_ctx.language.print_situation), 1)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.printSuppliersList && _ctx.printSuppliersList(...args)))
                    }, [
                      _hoisted_14,
                      _createTextVNode("  " + _toDisplayString(_ctx.language.suppliers) + " - " + _toDisplayString(_ctx.language.print_list), 1)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.printSuppliersSitList && _ctx.printSuppliersSitList(...args)))
                    }, [
                      _hoisted_15,
                      _createTextVNode("  " + _toDisplayString(_ctx.language.suppliers) + " - " + _toDisplayString(_ctx.language.print_situation), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_16
          ]),
          _hoisted_17
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"])
    ]))
  ], 64))
}